export { AvatarContextProvider } from '@fluentui/react-avatar';
export type { AvatarContextValue } from '@fluentui/react-avatar';
